(function () {
  var FILTER_KEYS = ['filter.p.vendor', 'filter.p.product_type', 'filter.p.tag'];

  function getCatalogFilters() {
    var params = new URLSearchParams(window.location.search);
    return {
      vendor: params.get('filter.p.vendor') || '',
      productType: params.get('filter.p.product_type') || '',
      tag: params.get('filter.p.tag') || '',
    };
  }

  function hasCatalogFilters(filters) {
    return !!(filters.vendor || filters.productType || filters.tag);
  }

  function cardMatchesFilters(card, filters) {
    if (filters.vendor && card.getAttribute('data-product-vendor') !== filters.vendor) {
      return false;
    }

    if (filters.productType && card.getAttribute('data-product-type') !== filters.productType) {
      return false;
    }

    if (filters.tag) {
      var tags = (card.getAttribute('data-product-tags') || '').split('||').filter(Boolean);
      if (tags.indexOf(filters.tag) === -1) {
        return false;
      }
    }

    return true;
  }

  function getBrandCatalogUrl(sidebar) {
    var raw = sidebar && sidebar.getAttribute('data-nxedc-brand-catalog-url');
    if (!raw) return null;
    return new URL(raw, window.location.origin);
  }

  function isOnCatalogPage(catalogUrl) {
    return !!(catalogUrl && window.location.pathname === catalogUrl.pathname);
  }

  function copyPreservedParams(fromUrl, toUrl) {
    ['filter.v.price.gte', 'filter.v.price.lte', 'sort_by'].forEach(function (key) {
      if (fromUrl.searchParams.has(key)) {
        toUrl.searchParams.set(key, fromUrl.searchParams.get(key));
      }
    });
  }

  function buildCatalogRedirectUrl(filters, catalogUrl) {
    var url = new URL(catalogUrl.href);
    var current = new URL(window.location.href);

    FILTER_KEYS.forEach(function (key) {
      url.searchParams.delete(key);
    });

    if (filters.vendor) url.searchParams.set('filter.p.vendor', filters.vendor);
    if (filters.productType) url.searchParams.set('filter.p.product_type', filters.productType);
    if (filters.tag) url.searchParams.set('filter.p.tag', filters.tag);

    copyPreservedParams(current, url);
    return url.pathname + url.search;
  }

  function buildCatalogNavUrl(paramName, paramValue, sidebar) {
    var catalogUrl = getBrandCatalogUrl(sidebar);
    if (!catalogUrl || !paramValue) return null;

    var url = new URL(catalogUrl.href);
    url.searchParams.set(paramName, paramValue);
    return url.pathname + url.search;
  }

  function buildToggleUrl(paramName, paramValue, isActive, sidebar, filters) {
    var catalogUrl = getBrandCatalogUrl(sidebar);
    var url = catalogUrl ? new URL(catalogUrl.href) : new URL(window.location.href);
    var current = new URL(window.location.href);

    FILTER_KEYS.forEach(function (key) {
      url.searchParams.delete(key);
    });

    if (isActive) {
      if (filters.vendor && paramName !== 'filter.p.vendor') {
        url.searchParams.set('filter.p.vendor', filters.vendor);
      }
      if (filters.productType && paramName !== 'filter.p.product_type') {
        url.searchParams.set('filter.p.product_type', filters.productType);
      }
      if (filters.tag && paramName !== 'filter.p.tag') {
        url.searchParams.set('filter.p.tag', filters.tag);
      }
    } else if (paramName === 'filter.p.vendor') {
      url.searchParams.set('filter.p.vendor', paramValue);
    } else if (paramName === 'filter.p.product_type') {
      if (filters.vendor) url.searchParams.set('filter.p.vendor', filters.vendor);
      url.searchParams.set('filter.p.product_type', paramValue);
    } else if (paramName === 'filter.p.tag') {
      if (filters.vendor) url.searchParams.set('filter.p.vendor', filters.vendor);
      if (filters.productType) url.searchParams.set('filter.p.product_type', filters.productType);
      url.searchParams.set('filter.p.tag', paramValue);
    }

    copyPreservedParams(current, url);
    return url.pathname + url.search;
  }

  function countForFilterOption(cards, filters, paramName, paramValue) {
    var testFilters = {
      vendor: filters.vendor,
      productType: filters.productType,
      tag: filters.tag,
    };

    if (paramName === 'filter.p.vendor') {
      testFilters.vendor = paramValue;
    } else if (paramName === 'filter.p.product_type') {
      testFilters.productType = paramValue;
    } else if (paramName === 'filter.p.tag') {
      testFilters.tag = paramValue;
    }

    var count = 0;
    cards.forEach(function (card) {
      if (cardMatchesFilters(card, testFilters)) {
        count += 1;
      }
    });
    return count;
  }

  function getFilterLabel(sidebar, paramName, paramValue) {
    if (!sidebar || !paramValue) return '';

    var links = sidebar.querySelectorAll('[data-filter-param="' + paramName + '"]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].getAttribute('data-filter-value') === paramValue) {
        return links[i].getAttribute('data-filter-label') || paramValue;
      }
    }

    return paramValue;
  }

  function syncCatalogHeading(sidebar, filters, onCatalog) {
    var headingEl = document.querySelector('[data-nxedc-catalog-title]');
    if (!headingEl) return;

    var defaultTitle = headingEl.getAttribute('data-nxedc-catalog-title') || headingEl.textContent;

    if (!onCatalog || !hasCatalogFilters(filters)) {
      headingEl.textContent = defaultTitle;
      return;
    }

    var titleParts = [];

    if (filters.productType) {
      titleParts.push(getFilterLabel(sidebar, 'filter.p.product_type', filters.productType));
    }
    if (filters.vendor) {
      titleParts.push(getFilterLabel(sidebar, 'filter.p.vendor', filters.vendor));
    }
    if (filters.tag) {
      titleParts.push(getFilterLabel(sidebar, 'filter.p.tag', filters.tag));
    }

    headingEl.textContent = titleParts.length ? titleParts.join(' · ') : defaultTitle;
  }

  function syncFilterCounts(sidebar, filters, cards, onCatalog) {
    if (!onCatalog) return;

    var hasFilters = hasCatalogFilters(filters);

    sidebar.querySelectorAll('.nxedc-bespoke-filter__link[data-filter-param]').forEach(function (link) {
      var paramName = link.getAttribute('data-filter-param');
      var paramValue = link.getAttribute('data-filter-value');
      if (!paramName || !paramValue) return;

      var count = countForFilterOption(cards, filters, paramName, paramValue);
      var countEl = link.querySelector('[data-filter-count]');
      if (countEl) {
        countEl.textContent = String(count);
      }

      var item = link.closest('li');
      if (item) {
        item.hidden = false;
      }
    });
  }

  function syncFilterLinks(sidebar, filters, onCatalog) {
    sidebar.querySelectorAll('.nxedc-bespoke-filter__link[data-filter-param]').forEach(function (link) {
      var paramName = link.getAttribute('data-filter-param');
      var paramValue = link.getAttribute('data-filter-value');
      if (!paramName || !paramValue) return;

      var isActive = false;
      var nextHref;

      if (onCatalog) {
        if (paramName === 'filter.p.vendor') isActive = filters.vendor === paramValue;
        if (paramName === 'filter.p.product_type') isActive = filters.productType === paramValue;
        if (paramName === 'filter.p.tag') isActive = filters.tag === paramValue;
        nextHref = buildToggleUrl(paramName, paramValue, isActive, sidebar, filters);
      } else {
        nextHref = buildCatalogNavUrl(paramName, paramValue, sidebar);
      }

      link.classList.toggle('is-active', isActive);
      if (nextHref) link.href = nextHref;
    });

    var clearLink = sidebar.querySelector('[data-nxedc-clear-filters]');
    if (clearLink) {
      var catalogUrl = getBrandCatalogUrl(sidebar);
      clearLink.href = catalogUrl ? catalogUrl.pathname : clearLink.getAttribute('data-collection-url') || clearLink.href;
    }
  }

  function bindCatalogFilterNavigation(sidebar) {
    sidebar.querySelectorAll('.nxedc-bespoke-filter__link[data-filter-param]').forEach(function (link) {
      if (link.dataset.nxedcCatalogBound === 'true') return;
      link.dataset.nxedcCatalogBound = 'true';

      link.addEventListener('click', function (event) {
        var catalogUrl = getBrandCatalogUrl(sidebar);
        if (!catalogUrl || isOnCatalogPage(catalogUrl)) return;

        var paramName = link.getAttribute('data-filter-param');
        var paramValue = link.getAttribute('data-filter-value');
        var targetHref = buildCatalogNavUrl(paramName, paramValue, sidebar);
        if (!targetHref) return;

        event.preventDefault();
        window.location.assign(targetHref);
      });
    });
  }

  function applyCatalogFilters() {
    var grid = document.querySelector('[data-nxedc-catalog-grid]');
    if (!grid) return;

    var sidebar = document.querySelector('[data-nxedc-bespoke-sidebar]');
    var filters = getCatalogFilters();
    var catalogUrl = sidebar ? getBrandCatalogUrl(sidebar) : null;
    var onCatalog = isOnCatalogPage(catalogUrl);

    if (!onCatalog && catalogUrl && hasCatalogFilters(filters)) {
      window.location.replace(buildCatalogRedirectUrl(filters, catalogUrl));
      return;
    }

    if (!onCatalog) {
      if (sidebar) {
        syncFilterLinks(sidebar, filters, false);
        syncCatalogHeading(sidebar, filters, false);
      }
      return;
    }

    var cards = grid.querySelectorAll('.nxedc-catalog-card[data-product-vendor]');
    var visible = 0;

    cards.forEach(function (card) {
      var show = !hasCatalogFilters(filters) || cardMatchesFilters(card, filters);
      card.hidden = !show;
      if (show) visible += 1;
    });

    var countEl = document.querySelector('[data-nxedc-catalog-count]');
    if (countEl) {
      countEl.textContent =
        'There are ' + visible + ' result' + (visible === 1 ? '' : 's') + ' in total';
    }

    var progressEl = document.querySelector('[data-nxedc-catalog-progress]');
    if (progressEl) {
      progressEl.textContent =
        "You've viewed " + visible + ' of ' + visible + ' result' + (visible === 1 ? '' : 's');
    }

    if (sidebar) {
      syncFilterCounts(sidebar, filters, cards, true);
      syncFilterLinks(sidebar, filters, true);
      syncCatalogHeading(sidebar, filters, true);
    }
  }

  function initBespokeCollection() {
    var sidebar = document.querySelector('[data-nxedc-bespoke-sidebar]');
    if (!sidebar) return;

    bindCatalogFilterNavigation(sidebar);

    var openBtn = sidebar.querySelector('[data-nxedc-bespoke-filter-open]');
    var closeBtn = sidebar.querySelector('[data-nxedc-bespoke-filter-close]');

    function openSidebar() {
      sidebar.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeSidebar() {
      sidebar.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', openSidebar);
    if (closeBtn) closeBtn.addEventListener('click', closeSidebar);

    sidebar.querySelectorAll('[data-nxedc-filter-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = btn.closest('.nxedc-bespoke-filter');
        if (!filter) return;
        var collapsed = filter.classList.toggle('is-collapsed');
        btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      });
    });

    var sortSelect = document.querySelector('[data-nxedc-bespoke-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }

    var grid = document.querySelector('[data-nxedc-bespoke-grid]');
    var gridModes = document.querySelector('[data-nxedc-bespoke-grid-modes]');
    if (grid && gridModes) {
      var savedCols = localStorage.getItem('nxedc-bespoke-grid-cols') || '4';
      grid.setAttribute('data-grid-cols', savedCols);
      gridModes.querySelectorAll('.nxedc-bespoke-grid-mode').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-grid-cols') === savedCols);
        btn.addEventListener('click', function () {
          var cols = btn.getAttribute('data-grid-cols');
          grid.setAttribute('data-grid-cols', cols);
          localStorage.setItem('nxedc-bespoke-grid-cols', cols);
          gridModes.querySelectorAll('.nxedc-bespoke-grid-mode').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
        });
      });
    }

    applyCatalogFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBespokeCollection);
  } else {
    initBespokeCollection();
  }

  document.addEventListener('shopify:section:load', initBespokeCollection);
})();
